import { createSelector } from '@reduxjs/toolkit';
import { selectCountersByDealType } from './selectCountersByDealType';
import { selectRoomTypeFilter } from './selectRoomTypeFilter';
import { ERoomType } from '../../../packages/JsonQuery';

const ROOM_TYPE_MAP_ENUMS_TO_STRING: Partial<Record<ERoomType | 'all', string>> = {
  [ERoomType.Studio]: 'studios',
  [ERoomType.FlatOneRoom]: 'oneRoom',
  [ERoomType.FlatTwoRooms]: 'twoRoom',
  [ERoomType.FlatThreeRooms]: 'threeRoom',
  [ERoomType.FlatFourRooms]: 'fourRoom',
  [ERoomType.FlatFreeLayout]: 'openPlan',
  all: 'total',
};

export const selectOffersCount = createSelector(
  selectCountersByDealType,
  selectRoomTypeFilter,
  (counters, roomType) => {
    const roomTypeKey = ROOM_TYPE_MAP_ENUMS_TO_STRING[roomType];

    if (!roomTypeKey || !counters) {
      return 0;
    }

    return counters[roomTypeKey as keyof typeof counters];
  },
);
